import { render, staticRenderFns } from "./BrandsItems.vue?vue&type=template&id=34bcbba0"
import script from "./BrandsItems.vue?vue&type=script&lang=js"
export * from "./BrandsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports